import React, { useState,useEffect } from "react";
import QueryTable from "../components/Query/Query";
import { NavLink, useSearchParams } from "react-router-dom";
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
// import { API, Auth} from 'aws-amplify';

const QuerySearch = (props) => {

	// const [ userInfo , setUserInfo ] = useState(false)
	const [ newSearches , setNewSearches ] = useState(0)	
	
	
	let [searchParams, setSearchParams] = useSearchParams();
	let project_id = searchParams.get("projectid");
	const [navLink, setNavLink] = useState('');

	const handleOnSearch = (report_id) => {
		setNavLink(`/queryserachreports?id=${report_id}&create=true`)
		// checkUser(props.user)
		setNewSearches(newSearches+1)
	};



	
	return (
		<Container>
			<h3>{console.log(newSearches)}</h3>
			<QueryTable project_id={project_id} onSearch={handleOnSearch} />
			<div style={{"display":"flex"}}>
				<NavLink to={`/queryserachreports?id=${123456789}&create=true`}>
					<Button variant="primary">Create Report</Button>{' '}
				</NavLink>
			</div>
		</Container>
	);

    
};

export default QuerySearch;